module.exports = __webpack_public_path__ + "img/1.48c6c708.jpg";